
    <div (click)="reject()" class="icon close-popup"><i class="fal fa-times" data-id="fairness-close-button"> </i></div>
    <!-- <div class="general-popup-content"> -->
    <!-- <div class="general-popup-text-wrap"> -->
    <!-- <h5 translate>fairness_popup.headline</h5> -->
    <!-- <p>Choose your seed provider</p> -->

    <h5 translate>fairness_popup.current</h5>
    <div class="_20px-spacer"></div>
    <div class="radio-wrap">
      <form class="radio-inline" [formGroup]="form" novalidate>
        <app-form-radio formControlName="radio" name="radio" data-id="fairness-seed-radio1" value="rndOrg">
          Random.org</app-form-radio
        >
        <app-form-radio formControlName="radio" name="radio" data-id="fairness-seed-radio2" value="moz">
          Mozilla Cripto Lib</app-form-radio
        >
        <app-form-radio formControlName="radio" name="radio" data-id="fairness-seed-radio3" value="own">
          Custom</app-form-radio
        >
      </form>
    </div>
    <app-form-input
      [disabled]="!(form.get('radio').value === 'own')"
      [value]="seedValue"
      [title]="'fairness_popup.client_seed' | translate"
      (change)="seedChanged($event.target)"
      data-id="fairness-clientSeed-input"
    ></app-form-input>

    <app-form-input
      [disabled]="true"
      [value]="getCurrentSeed().hashedServerSeed"
      [title]="'fairness_popup.server_seed_hash' | translate"
      data-id="fairness-serverSeed-readonly"
    ></app-form-input>

    <div class="_20px-spacer"></div>
    <br />
    <br />

    <h5 translate>fairness_popup.previous</h5>

    <app-form-input
      [disabled]="true"
      [value]="getPrevSeed().clSeed"
      data-id="fairness-prevClientSeed-readonly"
      [title]="'fairness_popup.client_seed' | translate"
    ></app-form-input>
    <app-form-input
      [disabled]="true"
      [value]="getPrevSeed().srvSeed"
      data-id="fairness-prevServerSeed-readonly"
      [title]="'fairness_popup.server_seed_plain' | translate"
    ></app-form-input>
    <app-form-input
      [disabled]="true"
      data-id="fairness-prevHashedSeed-readonly"
      [value]="getPrevSeed().hashedServerSeed"
      [title]="'fairness_popup.server_seed_hash' | translate"
    ></app-form-input>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/fairness-modal.component.ts.FairnessModalComponent.html